import { ConsiderationTypeHoldingClassTypes } from 'further-types/lp/realisation';
import { CurrencyCode } from 'further-types/lp/vehicle';

type GetRealisationTypeInput = {
  holdingClassInvestment: {
    currency: CurrencyCode;
  };
  vehicleCurrencyCode: CurrencyCode;
  realisationCurrencyCode: CurrencyCode;
};

const getRealisationType = ({
  holdingClassInvestment,
  vehicleCurrencyCode,
  realisationCurrencyCode,
}: GetRealisationTypeInput) => {
  const holdingClassCurrency = holdingClassInvestment.currency;

  const isHoldingClassInLcy = holdingClassCurrency === vehicleCurrencyCode;
  const isRealisationInLcy = realisationCurrencyCode === vehicleCurrencyCode;
  const isHoldingClassSameAsRealisation =
    holdingClassCurrency === realisationCurrencyCode;

  if (isHoldingClassInLcy) {
    return ConsiderationTypeHoldingClassTypes.LcyHoldingClass;
  }

  if (isRealisationInLcy) {
    return ConsiderationTypeHoldingClassTypes.LcyConsiderationForNonLcyHoldingClass;
  }

  if (!isHoldingClassSameAsRealisation) {
    return ConsiderationTypeHoldingClassTypes.ThreeCYNonLcyConsiderationNonLcyHoldingClass;
  }

  return ConsiderationTypeHoldingClassTypes.NonLcyConsiderationNonLcyHoldingClass;
};

export default getRealisationType;
